<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss">
    html.body, #app {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        background: url("./assets/images/page-bg.jpg");
    }

    #app {
        width: 100%;
        height: 100%;
    }
</style>
